// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4020d35a","455":"3ecb537c","977":"64123e73"}[chunkId] + ".chunk.js";
};